export default {
  header: '',
  link: 'Clear all',
  footer: ''
};



/** WEBPACK FOOTER **
 ** ./src/widgets/clear-all/defaultTemplates.js
 **/